import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const StyledIdsContainer = styled.div`
    color: ${Colors.gray70};
    display: flex;
    flex-wrap: wrap;
    gap: 0 ${SPACING.SMALL_2};
    @media ${BreakpointsMinQuery.sm} {
        gap: 0 ${SPACING.SMALL_5};
    }
`;
